import { useTranslation } from "react-i18next";
import { Suspense, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import AppLoading from "../app-loading/app-loading";
import DeliveryCashSearch from "./delivery-cash-search";
import DeliveryCashDatatable from "./delivery-cash-datatable";
import DeliveryCashService from "../../services/deliverycash/deliverycashservice";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import HandoverRequestHistoryDialog from "./handover-history-dialog";

const DeliveryCashMain = () => {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);
  const [cashTrackData, setCashTrackData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [lastFilterPayload, setLastFilterPayload] = useState<any>(null);
  const [showHistoryDialog, setShowHistoryDialog] = useState(false);

  const handleSearch = async (filterPayload: any) => {
    setLoading(true);
    setLastFilterPayload(filterPayload);
    try {
      const result = await DeliveryCashService.GetDeliveryCashDetails(filterPayload);
      if (Array.isArray(result) && result.length > 0) {
        setCashTrackData(result);
      } else {
        // toast.current?.show({
        //   severity: "info",
        //   summary: "No Data",
        //   detail: "No cash collection records found.",
        // });
        setCashTrackData([]);
      }
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch data.",
      });
      setCashTrackData([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Suspense fallback={<AppLoading />}>
      <Toast ref={toast} position="top-right" />
      <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
       <div className="col-12 flex justify-content-between align-items-center mb-2">
            <h5 className="ml-1 mb-0">{t("Delivery Executive Cash Collection")}</h5>
          <Button
            icon="pi pi-history"
            label="History"
            onClick={() => setShowHistoryDialog(true)}
            severity="info"
            className="text-sm px-3"
          />
      </div>
        <div className="col-12">
          <DeliveryCashSearch setLoading={setLoading} onSearch={handleSearch}  onReset={() => setCashTrackData([])}/>
        </div>

        <div className="col-12">
          <DeliveryCashDatatable data={cashTrackData} loading={loading} 
          refreshData={() => lastFilterPayload && handleSearch(lastFilterPayload)} />
        </div>
      </div>

 {/* History Dialog */}
      <Dialog
        visible={showHistoryDialog}
        onHide={() => setShowHistoryDialog(false)}
        header="Handover Request History"
        modal
        style={{ width: "70vw" }}
      >
        <HandoverRequestHistoryDialog
          visible={showHistoryDialog}
          onHide={() => setShowHistoryDialog(false)}
        />
      </Dialog>
      {loading && <AppLoading />}
    </Suspense>
  );
};

export default DeliveryCashMain;
